import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=03bb70b6&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"
import style0 from "./Project.vue?vue&type=style&index=0&id=03bb70b6&prod&lang=scss&scoped=true"
import style1 from "./Project.vue?vue&type=style&index=1&id=03bb70b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb70b6",
  null
  
)

export default component.exports